var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"px-4 py-8",attrs:{"id":"trial-info"}},[_c('h3',{staticClass:"mb-2"},[_vm._v("Pay-As-You-Go Free Trail")]),_c('p',{staticClass:"text-gray-dark text-sm"},[_vm._v("Expires "+_vm._s(_vm.trialEndDateWrittenOut))])])
}
var staticRenderFns = []

export { render, staticRenderFns }